package com.evoapps.evoshift.data.dto.roster

import com.evoapps.evoshift.data.dto.system.MetadataDto
import kotlinx.serialization.Serializable

/**
 * `absences/{id}`. SH-223: [type] is always one of the four values apps before SH-223 decode
 * (their AbsenceTypeDto enum fails on any other, which loses the whole list): the nearest legacy
 * type of the request (AbsenceMapper.legacyType). [kind] is the precise type when it is not one of
 * those four. Read here as text, so a value this version does not know never fails the list either.
 */
@Serializable
data class AbsenceDto(
    val id: String,
    val userId: String,
    val workplaceId: String? = null,
    val type: String,
    val status: String,
    val startDate: String,
    val endDate: String,
    val reason: String? = null,
    val attachmentUrl: String? = null,
    val processedBy: String? = null,
    val processedAt: String? = null,
    val metadata: MetadataDto,
    /** SH-57: sick leave paid at 100%. */
    val sickPayFull: Boolean = false,
    /** SH-164: the manager's optional reason for a rejection. */
    val rejectionReason: String? = null,
    // --- SH-223: the request module's fields (older apps skip unknown fields) ---
    /** The precise type (AbsenceType name) when [type] holds only the nearest legacy one. */
    val kind: String? = null,
    /** "HH:mm": part of one day. */
    val startTime: String? = null,
    val endTime: String? = null,
    /** OccasionReason name (urlop okolicznościowy). */
    val occasion: String? = null,
    /** CareRecipient name (zasiłek opiekuńczy). */
    val careFor: String? = null,
    /** LimitUnit name (childcare, force majeure). */
    val limitUnit: String? = null,
    val children: Int? = null,
    val compensatedOvertimeHours: Double? = null,
    val overrideNote: String? = null
)

/** The four `type` values every app version decodes (apps before SH-223 as an enum). */
@Serializable
enum class AbsenceTypeDto {
    SICK_LEAVE,
    VACATION,
    ON_DEMAND,
    FORCE_MAJEURE
}

@Serializable
enum class AbsenceStatusDto {
    PENDING,
    APPROVED,
    REJECTED
}
